import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Merge } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { PatientPicker } from "@/components/ApptDialog";

export const UnirFicha = ({ patient, onDone }) => {
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const [otro, setOtro] = useState(null);
  const [queda, setQueda] = useState("este");
  const [busy, setBusy] = useState(false);
  const principal = queda === "este" ? patient : otro;
  const borrada = queda === "este" ? otro : patient;
  const unir = async () => {
    if (!window.confirm(`Se quedará la ficha de «${principal.nombre}» y se borrará la de «${borrada.nombre}». Sus citas, tratamientos, cobros, facturas, cuestionarios y presupuestos pasan a la que se queda, y los datos que falten se completan. No se puede deshacer. ¿Continuar?`)) return;
    setBusy(true);
    try {
      const { data } = await api.post("/patients/unir", { principal_id: principal.id, otros: [borrada.id] });
      toast.success(`Fichas unidas${data.rellenados.length ? ` · ${data.rellenados.length} datos completados` : ""}`);
      setOpen(false);
      if (principal.id !== patient.id) nav(`/pacientes/${principal.id}`);
      else onDone();
    } catch (e) {
      toast.error(errMsg(e));
    }
    setBusy(false);
  };
  const Opcion = ({ v, p }) => (
    <label className={`flex cursor-pointer items-start gap-2 rounded-md border p-2 text-sm ${queda === v ? "border-[#1E3A8A] bg-sky-50" : "border-slate-200"}`}>
      <input type="radio" checked={queda === v} onChange={() => setQueda(v)} data-testid={`unir-queda-${v}`} className="mt-1" />
      <span><b>{p.nombre}</b><span className="block text-xs text-slate-500">{[p.codigo && `Ficha nº ${p.codigo}`, p.centro, p.telefono].filter(Boolean).join(" · ") || "Sin más datos"}</span></span>
    </label>
  );
  return (
    <>
      <Button variant="outline" onClick={() => { setOtro(null); setQueda("este"); setOpen(true); }} data-testid="unir-ficha-btn"><Merge className="h-4 w-4 mr-1" />Unir con otra ficha</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md" data-testid="unir-ficha-dialog">
          <DialogHeader><DialogTitle className="font-[Outfit]">Unir fichas repetidas</DialogTitle></DialogHeader>
          <p className="text-xs text-slate-500 -mt-2">Busca la otra ficha del mismo paciente y elige cuál se queda.</p>
          <PatientPicker value={otro?.id} label={otro?.nombre} onPick={(p) => setOtro(p && p.id !== patient.id ? p : null)} />
          {otro && (
            <div className="space-y-2">
              <p className="text-[11px] font-semibold uppercase text-slate-500">¿Qué ficha se queda?</p>
              <Opcion v="este" p={patient} />
              <Opcion v="otro" p={otro} />
            </div>
          )}
          <div className="flex justify-end gap-2">
            <Button variant="outline" onClick={() => setOpen(false)}>Cancelar</Button>
            <Button disabled={!otro || busy} onClick={unir} data-testid="unir-ficha-confirmar" className="bg-[#1E3A8A] hover:bg-[#1E40AF]">Unir fichas</Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
